import React, { Component } from 'react';

import "./Header.scss"
import headerLogo from "../../static/images/mobile/header.jpg"

class Header extends Component {
    render() {
      return (
        <header>
            <img src={headerLogo} alt="" title="" />
        </header>
      );
    }
  }
  
  export default Header;
  


// WEBPACK FOOTER //
// ./src/Components/App/Header.js